import { useRoleStore } from '../store/roleStore';

export function useIsAdmin(): boolean {
  const myRole = useRoleStore(s => s.myRole);
  const demoRole = useRoleStore(s => s.demoRoleOverride);
  const effective = demoRole ?? myRole;
  return effective?.roleSlug === 'super_admin' || effective?.roleSlug === 'eoc_director';
}
